/*
* @描述:回款详情
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/13 20:50
*/
<template>
    <van-popup v-model.sync="dialogVisible"
               :style="{ width: '100%',height: '100%' }">
        <div v-loading="loading" class="public_container">
            <div class="returnNavBar">
                <ReturnNavBar :isAllFunctions="false"
                              :isCustomReturnEvent="true"
                              :isTitleNormal="true"
                              title="返回"
                              @returnEvent="handleDialogClose"></ReturnNavBar>
            </div>
            <div class="detail_wrap_container">
                <div class="m_page_little_title">
                    <span class="title">订单信息</span>
                </div>
                <div class="detail_chunk_wrap">
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">关联订单</div>
                        <div class="form_item_value" v-text="repaymentInfo.order_no"></div>
                    </div>
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">客户联系人</div>
                        <div v-if="repaymentInfo.customer_contact_info" class="form_item_value"
                             v-text="repaymentInfo.customer_contact_info.name"></div>
                    </div>
                    <div class="m_detail_form_item">
                        <div class="form_item_label">订单总金额</div>
                        <div class="form_item_value" v-text="repaymentInfo.order_amount"></div>
                    </div>
                </div>
                <div class="m_page_little_title">
                    <span class="title">回款信息</span>
                </div>
                <div class="detail_chunk_wrap">
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">回款公司</div>
                        <div class="form_item_value" v-text="repaymentInfo.payment_company_name"></div>
                    </div>
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">回款日期</div>
                        <div class="form_item_value" v-text="repaymentInfo.order_amount"></div>
                    </div>
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">回款方式</div>
                        <div class="form_item_value" v-text="repaymentInfo.payment_method_name"></div>
                    </div>
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">本次回款金额</div>
                        <div class="form_item_value" v-text="repaymentInfo.payment_amount"></div>
                    </div>
                    <div class="m_detail_form_item flex_vertical mb_8">
                        <div class="form_item_label">备注</div>
                        <div class="form_item_value" v-text="repaymentInfo.remark?repaymentInfo.remark:'--'"></div>
                    </div>
                    <div class="m_detail_form_item flex_vertical">
                        <div class="form_item_label">附件</div>
                        <div class="form_item_value">
                            <ul v-if="repaymentInfo.attachments&&repaymentInfo.attachments.length"
                                class="upload_file_list">
                                <li v-for="(file,file_idx) in repaymentInfo.attachments"
                                    class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="下载"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                  @click="handleClickDownloadFile(file)">
                                                <i class="iconfont icon-daochu"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                            </ul>
                            <div v-else>--</div>
                        </div>
                    </div>
                </div>
            </div>
            <el-image ref="preview_img"
                      :preview-src-list="previewImgList"
                      :src="previewImgSrc"
                      style="display:none">
            </el-image>
        </div>
    </van-popup>
</template>
<script>
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import {ReceivableDetail} from "@/api";
import {getOSSData} from "@/utils/uploadOss";

export default {
    name: "RepaymentDetail",
    data() {
        return {
            loading: false,
            repaymentInfo: {},
            previewImgList: [],
            previewImgSrc: '',
            defaultImg: require('@/assets/images/default.jpg'),
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        receivable_no: {
            type: String,
            default: '',
        },
    },
    components: {
        ReturnNavBar,
    },
    created() {
        this.getReceivableDetail()
    },
    mounted() {

    },
    methods: {
        // 详情
        getReceivableDetail() {
            this.loading = true;
            ReceivableDetail({receivable_no: this.receivable_no}).then((res) => {
                if (res.code === 200) {
                    this.repaymentInfo = res.data.basic_info;
                }
                this.loading = false;
            });
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不允许预览，请下载后查看')
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },

        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
            this.$emit('update:receivable_no', '')
        },
    },
}
</script>
<style lang="scss" scoped>

</style>